/* @flow */

export default class RefuseInvoiceRequest {
  companyId: number;
  invoiceId: number;
  reason: string;
}
